import * as Service from '../services';

export default {
  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllAttributesGroups({ commit }) {
    const response = await Service.fetchAllAttributesGroups();
    commit('setProperty', { property: 'groups', payload: response });
  },

  /**
   *
   * @param dispatch
   * @param payload
   * @returns {Promise<void>}
   */
  async createAttributeGroup({ dispatch }, payload) {
    await Service.createAttributesGroups(payload);
    await dispatch('fetchAllAttributesGroups');
  },

  /**
   *
   * @param dispatch
   * @param groupId
   * @param payload
   * @returns {Promise<void>}
   */
  async updateAttributeGroup({ dispatch }, { groupId, payload }) {
    await Service.updateAttributeGroups(payload, groupId);
    await dispatch('fetchAllAttributesGroups');
  },

  /**
   *
   * @param dispatch
   * @param groupId
   * @returns {Promise<void>}
   */
  async deleteAttributeGroup({ dispatch }, groupId) {
    await Service.deleteAttributeGroups(groupId);
    await dispatch('fetchAllAttributesGroups');
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllAttributes({ commit }) {
    const response = await Service.fetchAllAttributes();
    commit('setProperty', { property: 'attributes', payload: response });
  },

  /**
   *
   * @param dispatch
   * @param payload
   * @returns {Promise<void>}
   */
  async createAttribute({ dispatch }, payload) {
    await Service.createAttributes(payload);
    await dispatch('fetchAllAttributes');
  },

  /**
   *
   * @param dispatch
   * @param attributeId
   * @param payload
   * @returns {Promise<void>}
   */
  async updateAttribute({ dispatch }, { attributeId, payload }) {
    await Service.updateAttribute(payload, attributeId);
    await dispatch('fetchAllAttributes');
  },

  /**
   *
   * @param dispatch
   * @param attributeId
   * @returns {Promise<void>}
   */
  async deleteAttribute({ dispatch }, attributeId) {
    await Service.deleteAttribute(attributeId);
    await dispatch('fetchAllAttributes');
  },

  /**
   *
   * @param commit
   * @param groupId
   * @returns {Promise<void>}
   */
  async fetchAttributesByGroup({ commit }, { groupId }) {
    const response = await Service.fetchAttributesByGroups(groupId);
    commit('setProperty', { property: 'attributes', payload: response });
  },
};
